import React from 'react';
import './Gamification.css';

const Gamification = () => {
  // Dummy data for now
  const user = {
    name: 'Agent Smith',
    tier: 'Gold',
    league: 'Pro',
    promotionProgress: '75%',
  };

  return (
    <div className="gamification">
      <h2>Gamification & Tier List</h2>
      <p>Welcome, {user.name}!</p>
      <p>Current Tier: {user.tier}</p>
      <p>Current League: {user.league}</p>
      <div className="progress-bar-container">
        <p>Promotion Progress</p>
        <div className="progress-bar">
          <div className="progress" style={{ width: user.promotionProgress }}></div>
        </div>
      </div>
    </div>
  );
};

export default Gamification;